import { render, staticRenderFns } from "./designer_details_list.vue?vue&type=template&id=87b44c86"
import script from "./designer_details_list.vue?vue&type=script&lang=js"
export * from "./designer_details_list.vue?vue&type=script&lang=js"
import style0 from "./designer_details_list.vue?vue&type=style&index=0&id=87b44c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports